import { create } from "zustand";

import { DEFAULT_TIMEZONE } from "~/screens/Scheduling/InitialVisit/utils/date-time-utils";
import { TimeZone } from "~/shared.types";

type SchedulingTimezoneStore = {
  selectedTimeZone: TimeZone;
  setSelectedTimeZone: (tz: TimeZone) => void;
  isTimezoneSelectOpen: boolean;
  setIsTimezoneSelectOpen: (open: boolean) => void;
};

export const useSchedulingTimezoneStore = create<SchedulingTimezoneStore>()(
  (set) => ({
    selectedTimeZone: DEFAULT_TIMEZONE,
    setSelectedTimeZone: (tz) => set({ selectedTimeZone: tz }),
    isTimezoneSelectOpen: false,
    setIsTimezoneSelectOpen: (open) => set({ isTimezoneSelectOpen: open }),
  }),
);
